import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { UserLoginService } from '../../service/aws/user.login.service';

@Component({
    selector: 'app-employee-engagementlogout',
    templateUrl: './logout.component.html'
})
export class LogOutComponent {
    constructor(public router: Router,
                public userService: UserLoginService) {
    }

    OnInit() {
        this.userService.logout();
        this.router.navigate(['login']);
    }
}
